<div class="flex flex-row flex-wrap justify-center mb-16">
  <div class="border border-[#8f687f] p-1 py-10 w-[425px] h-100 text-center rounded-sm bg-light-purple shadow relative">
    @if (isLoading) {
      <div class="absolute inset-0 flex items-center justify-center bg-light-purple bg-opacity-80 z-10">
        <div class="flex flex-col items-center">
          <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-[#155bab]"></div>
          <span class="mt-2 text-sm text-gray-600">Loading...</span>
        </div>
      </div>
    }
    @switch (graph) {
      @case (graphType.line) {
        <div class="flex flex-col h-full px-4">
          <div class="flex justify-between items-start mb-2">
            <div class="flex flex-col">
              <span class="font-bold text-sm uppercase">{{ reportCardData.title }}</span>
              <span class="text-xs text-gray-600">Growth Over Time</span>
            </div>
            <span class="text-5xl font-bold text-[#155bab] pr-6">{{ reportCardData.total }}</span>
          </div>
          
          <div style="position: relative; height: 200px; width: 100%;">
            <canvas #line></canvas>
          </div>
          <div class="sr-only">
            <p>{{ reportCardData.title }} Growth Over Time report. Total: {{ reportCardData.total }}.</p>
            <ul>
              <li *ngFor="let label of reportCardData.labels ?? []; let i = index">
                {{ label }}: {{ reportCardData.data?.[i] ?? 0 }}
              </li>
            </ul>
          </div>
          <div class="text-right mt-2">
            <button
              type="button"
              class="bg-transparent border-0 cursor-pointer p-0 text-sm font-semibold text-black underline"
              [attr.aria-label]="'See all ' + reportCardData.type + ' for ' + reportCardData.title"
              (click)="viewDistrictReport()">
              See all {{ reportCardData.type }}
            </button>
          </div>
        </div>
      }
      @case (graphType.doughnut) {
        <div class="flex flex-col h-full px-4">
          <div class="flex justify-between items-start mb-2">
            <div class="flex flex-col">
              <span class="font-bold text-sm uppercase">{{ reportCardData.title }}</span>
            </div>
            <span class="text-5xl font-bold text-[#155bab] pr-5">{{ reportCardData.total }}</span>
          </div>
          
          <div style="position: relative; height: 200px; width: 100%;">
            <canvas #doughnut></canvas>
          </div>
          <div class="sr-only">
            <p>{{ reportCardData.title }} report. Total: {{ reportCardData.total }}.</p>
            <ul class="sr-only">
              <li *ngFor="let item of reportCardData.labels ?? []; let i = index">
                {{ item }}: {{ reportCardData.data?.[i] ?? 0 }}%
              </li>
            </ul>
          </div>
          
          <div class="text-right mt-2">
            <button
              type="button"
              class="bg-transparent border-0 cursor-pointer p-0 text-sm font-semibold text-black underline"
              [attr.aria-label]="'See all ' + reportCardData.type + ' for ' + reportCardData.title"
              (click)="viewReport()">
              See all {{ reportCardData.type }}
            </button>
          </div>
        </div>
      }
    }
  </div>
</div>